import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { Col, Form, Row } from 'react-bootstrap';

import AuthLayout from '../../../layouts/AuthLayout/AuthLayout';
import { useLanguage } from '../../../context/LanguageProvider/LanguageProvider';

import { NioButton, NioField, NioToaster, NioBrand, NioCard } from '../../../components';
import AuthLogo from '../../../components/AuthLogo/AuthLogo';

export default function ForgotPassword() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    mode: 'onBlur',
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = () => {
    setShowSuccess(true);
    reset();
    setTimeout(() => {
      setShowSuccess(false);
    }, 3000);
    navigate('/auth/reset-password');
  };

  return (
    <AuthLayout titleKey="auth.forgot.docTitle" rootClass="layout-1">
      {showSuccess && (
        <NioToaster
          variant="success"
          messages={[
            {
              id: 1,
              header: t('auth.forgot.toastTitle'),
              body: t('auth.forgot.toastBody'),
            },
          ]}
        />
      )}

      <NioCard className="nk-form-card card card-gutter-md nk-auth-form-card mx-md-9 mx-xl-auto">
        <NioCard.Body>
          <div className="nk-form-card-head text-center pb-5">
            <div className="form-logo mb-4">
              <AuthLogo />
            </div>
            <h3 className="title mb-2">{t('auth.forgot.title')}</h3>
            <p className="text">
              {t('auth.forgot.sub')}{' '}
              <Link to="/auth/login" className="btn-link text-primary">
                {t('auth.forgot.loginLink')}
              </Link>
              .
            </p>
          </div>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="gy-4">
              <Col xs={12}>
                <NioField label={t('auth.forgot.email')} htmlFor="email">
                  <NioField.Input
                    type="email"
                    id="email"
                    placeholder={t('auth.forgot.emailPh')}
                    errors={errors.email}
                    {...register('email', {
                      required: t('auth.forgot.err.required'),
                      pattern: {
                        value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                        message: t('auth.forgot.err.invalidEmail'),
                      },
                    })}
                  />
                </NioField>
              </Col>
              <Col xs={12}>
                <div className="form-group">
                  <NioButton className="btn-primary btn-block" label={t('auth.forgot.submit')} />
                </div>
              </Col>
            </Row>
          </Form>
        </NioCard.Body>
      </NioCard>
    </AuthLayout>
  );
}
